const evite = window.evite = window.evite || {};

export function show(subject) {
  if (!subject) {
    evite.warn('Expected subject to be non null');
    return;
  }

  if('show' in subject){
    subject.show();
  }
  else {
    subject.classList.remove('hidden');
  }
}

export function hide(subject){
  if (!subject) {
    evite.warn('Expected subject to be non null');
    return;
  }

  if ('hide' in subject) {
    subject.hide();
  }
  else {
    subject.classList.add('hidden');
  }
}

export function toggle(subject, showElement = false) {
  if(!subject){
    return;
  }

  if(arguments.length === 1){
    if(subject.toggle){
      subject.toggle();
      return;
    }

    showElement = subject.offsetParent === null;
  }

  if(showElement){
    show(subject);
  } else {
    hide(subject);
  }
}

export function appendChild(subject, child){
  if(!subject){
    return;
  }

  if(subject.append){
    subject.append(child);
  } else {
    subject.appendChild(child);
  }

}

export function appendChildren(subject, children) {
  if(!subject){
    return;
  }

  children = arguments.length === 2 && Array.isArray(children)?
    children:
    Array.prototype.slice.call(arguments, 1);

  for(let i = 0; i < children.length; ++i) {
    const childOrArray = children[i];
    if (Array.isArray(childOrArray)) {
      appendChildren(subject, childOrArray);
    } else {
      appendChild(subject, childOrArray);
    }
  }
}

export function removeChildren(subject) {
  if(!subject){
    return;
  }
  if ('removeChildren' in subject) {
    subject.removeChildren();
  }
  else {
    while(subject.lastChild) {
      subject.removeChild(subject.lastChild);
    }
  }
}


export function buildScriptTag({ src, type, defer, async, onLoad, onError, className, innerText, innerHTML }) {
  defer = Boolean(defer);
  async = Boolean(async);
  onLoad = onLoad || '';
  onError = onError || '';
  className = className || '';
  innerText = innerText || '';

  const id = evite.guid('script-id');

  let scriptTag = document.createElement('script');
  scriptTag.type = type || 'text/javascript';
  scriptTag.async = async;
  scriptTag.defer = defer;
  scriptTag.className = className;

  scriptTag.addEventListener('load', function(){
    evite.resolve(src);
    onLoad();
  });

  scriptTag.addEventListener('error', function(){
    evite.reject(src);
    onError();
  });
  if (src) {
    scriptTag.src = src;
  } else if (innerHTML) {
    scriptTag.innerHTML = innerHTML;
  } else if (innerText) {
    scriptTag.innerText = innerText;
  }

  return scriptTag
}

// TODO - refactor
export function addScriptTag({ src, type, defer, async, onLoad, onError, className }) {

  evite.when('document.ready').then(function(){
    const scriptTag = buildScriptTag({ src, type, defer, async, onLoad, onError, className });

    appendChild(document.head, scriptTag);
  });
}

export function remove(el) {
  if(el && el.parentElement){
    el.parentElement.removeChild(el);
  }
}

export function getElementAttributes(el) {
  let json = {};
  if (el) {
    Array.from(el.attributes).forEach(function (attribute) {
      json[attribute.name] = attribute.value;
    });
  }
  return json;
}


export function createElement(elOrTagNameOrComponent, props, ...children) {
  let el;
  if (typeof elOrTagNameOrComponent === 'string') {
    let elStr = elOrTagNameOrComponent;
    elStr = elStr.trim();

    let div = document.createElement('div');
    div.innerHTML = elStr.trim();
    el = div.firstChild;
  }
  else if ('render' in elOrTagNameOrComponent) {
    el = elOrTagNameOrComponent.render();
  }
  else if (typeof elOrTagNameOrComponent === 'function') {
    el = elOrTagNameOrComponent(props);
    props = null;
  }
  else {
    el = elOrTagNameOrComponent;
  }

  if(props){
    mapElementToProps(el, props);
  }

  const length = children.length;
  for(var i = 0; i < length; ++i) {
    let child = children[i];
    child = createElement(child);

    appendChild(el, child)
  }

  return el;
}

export function mapElementToProps(el, props) {
  if(!el){
    return null;
  }
  for(let property in props) {
    const value = props[property];
    if ((property === 'styles' || property === 'style') && typeof value === 'object') {
      css(el, value);
    }
    else if (property === 'dangerouslySetInnerHTML') {
      el.innerHTML = value;
    }
    else if (property === 'classList') {
      let list;
      if(typeof value === 'string'){
        list = value.split(/\s+/);
      }
      else if(typeof value === 'object' && 'forEach' in value){
        list = value;
      }
      else {
        list = [value];
      }
      list.forEach(function (className) {
        addClass(el, className);
      });
    }
    else if (property === 'className') {
      el.setAttribute('class', value);
    }
    else if (/^on[A-Z]/.test(property) && typeof value === 'function') {
      const eventType = property.replace(/^on/, '').toLowerCase();
      evite.listenTo(el, eventType, value);
    }
    else {
      el.setAttribute(property, value);
    }
  }

  return el;
}

export function css(el, styles) {
  //evite.assert(el, 'Expected element to be non null.');

  if (!el) {
    return;
  }

  if(!styles) {
    el.style.cssText = '';
    return;
  }

  for(let prop in styles) {
    let value = styles[prop];
    if (typeof value === 'number') {
      el.style[prop] = value + 'px';
    }
    else {
      el.style[prop] = value;
    }
  }
}

export function hasClass(el, className) {
  return el && el.classList && el.classList.contains(className) || false;
}

export function addClass(el, className) {
  if (el && el.classList) {
    el.classList.add(className);
  }
}

export function removeClass(el, className) {
  if (el && el.classList) {
    el.classList.remove(className);
  }
}

export function toggleClass(el, className, add) {
  if (arguments.length === 2) {
    add = !hasClass(el, className)
  }

  if (add) {
    addClass(el, className);
  }
  else {
    removeClass(el, className);
  }
}

/**
 * Scroll to an element on the page
 *
 * modified from https://stackoverflow.com/questions/17722497/scroll-smoothly-to-specific-element-on-page
 * https://jsfiddle.net/s61x7c4e/
 *
 * @param element dom element
 * @param duration
 * @param marginTop additional header room for fixed elements, or if you want to scroll above `element`
 */
export function scrollTo(element, duration, marginTop=0) {
  const startingY = window.pageYOffset;
  const elementY = window.pageYOffset + element.getBoundingClientRect().top - marginTop;
  // If element is close to page's bottom then window will scroll only to some position above the element.
  const tooClose = document.body.scrollHeight - elementY < window.innerHeight;
  const targetY =  tooClose ? document.body.scrollHeight - window.innerHeight : elementY;
  const diff = targetY - startingY;
  // Easing function: easeInOutCubic
  // From: https://gist.github.com/gre/1650294
  function easing(t) {
    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  }
  let start;

  if(!diff)
    return;

  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  window.requestAnimationFrame(function step(timestamp) {
    if(!start)
      start = timestamp;
    // Elapsed miliseconds since start of scrolling.
    let time = timestamp - start;
    // Get percent of completion in range [0, 1].
    let percent = Math.min(time / duration, 1);
    // Apply the easing.
    // It can cause bad-looking slow frames in browser performance tool, so be careful.
    percent = easing(percent);

    window.scrollTo(0, startingY + diff * percent);

    // Proceed with animation as long as we wanted it to.
    if(time < duration)
      window.requestAnimationFrame(step)
  });
}

let idleLoadingQueue = [];
let loadingInProgress;
export function addToLoadingQueue({ url, priority }) {
  evite.when('window.load').then(function () {
    priority = priority || 0;
    if (url) {
      idleLoadingQueue.splice(priority, 0, url);
      if (!loadingInProgress) {
        evite.requestIdleCallback(loadNextInQueue);
      }
    }
  });

  return evite.when(url)
}

function loadNextInQueue() {
  if (!loadingInProgress && idleLoadingQueue.length) {
    loadingInProgress = true;


    const url = idleLoadingQueue.pop();

    const isImage = /\.(jpeg|jpg|gif|png)\b/i.test(url);
    if(isImage){
      const image = new Image();
      let completeHandler = handleQueueLoadComplete.bind(null, url, image);
      image.addEventListener('load', completeHandler);
      image.addEventListener('error', completeHandler);
      image.src = url;
      return;
    }

    const isCss = /\.(css)\b/i.test(url);
    if(isCss){
      const link = evite.dom.createElement('<link rel="stylesheet" media="none"/>', {href: url });
      let completeHandler = handleQueueLoadComplete.bind(null, url, link);
      link.addEventListener('load', completeHandler);
      link.addEventListener('error', completeHandler);
      document.body.appendChild(link);
      return;
    }

    handleQueueLoadComplete();
  }
}

function handleQueueLoadComplete(url, value){
  loadingInProgress = false;
  if(url){
    evite.resolve(url, value);
  }

  evite.requestIdleCallback(loadNextInQueue);
}

export function isDomNode(o) {
  if (!o) { return false; }
  return (
    (window.HTMLElement && o instanceof HTMLElement) ||
    o.nodeType === 1 && typeof o.nodeName === 'string'
  );
}

Object.assign(evite, exports);

evite.dom = evite.dom || {};
Object.assign(evite.dom, exports);



// WEBPACK FOOTER //
// ./assets/es6/common/evite/dom.es6